import type { CurrentUserDto } from '../types/UserDtos';
import { getCurrentUser } from './react/services/CurrentUser';
import { isFeatureEnabled } from './react/services/Features';
import { hasBasicHr, isAdmin } from './react/services/User';
import * as R from './routes';

const routePairsForHr = isFeatureEnabled('FEATURE_adminNavigationRefresh')
    ? {
          [R.YOUR_SURVEYS_SHARED]: R.YOUR_SURVEYS_COMPANY,
          [R.YOUR_SURVEYS_SHARED_WITH_SURVEY]: R.YOUR_SURVEYS_COMPANY_WITH_SURVEY,
          [R.YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT]: R.YOUR_SURVEYS_COMPANY_WITH_SURVEY_PRINT,
      }
    : {
          [R.YOUR_SURVEYS_SHARED]: R.ADMIN_SURVEYS,
          [R.YOUR_SURVEYS_SHARED_WITH_SURVEY]: R.ADMIN_SURVEYS_WITH_SURVEY,
          [R.YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT]: R.ADMIN_SURVEYS_WITH_SURVEY_PRINT,
          [R.OBJECTIVES_COMPANY_CYCLES]: R.ADMIN_OBJECTIVES_SELECT_CYCLE,
          [R.AI_COACH]: R.ADMIN_AI_COACH,
          [R.AI_COACH_CHAT]: R.ADMIN_AI_COACH_CHAT,
          [R.AI_COACH_CHAT_HISTORY]: R.ADMIN_AI_COACH_CHAT_HISTORY,
          [R.AI_COACH_CHAT_NEW]: R.ADMIN_AI_COACH_CHAT_NEW,
          [R.AI_COACH_COACHES]: R.ADMIN_AI_COACH_COACHES,
          [R.AI_COACH_RESOURCES]: R.ADMIN_AI_COACH_RESOURCES,
      };

const routePairsForTech = isFeatureEnabled('FEATURE_adminNavigationRefresh')
    ? {}
    : {
          // tech admins have access to
          [R.PEOPLE_DIRECTORY]: R.ADMIN_USERS_DIRECTORY,
      };

const routePairsAll = {
    ...routePairsForHr,
    ...routePairsForTech,
};

const getRoutePairsForUser = (user: CurrentUserDto): Partial<typeof routePairsAll> => {
    if (hasBasicHr(user)) {
        return routePairsAll;
    } else if (isAdmin(user)) {
        return routePairsForTech;
    } else {
        return {};
    }
};

export const getAdminRouteForNavigation = (oldRoute: keyof typeof routePairsAll) => {
    return getAdminRouteForNavigationForUser(getCurrentUser(), oldRoute);
};

export const getAdminRouteForNavigationForUser = (user: CurrentUserDto, oldRoute: keyof typeof routePairsAll) => {
    const newRoute = getRoutePairsForUser(user)[oldRoute];

    return newRoute ?? oldRoute;
};

export const getRedirectsForHR = () => {
    const user = getCurrentUser();

    const newNavRedirects = Object.entries(getRoutePairsForUser(user)).filter(
        ([oldPath, newPath]) => oldPath !== newPath
    );

    return newNavRedirects;
};
